<template>
  <div>
    <div class="header-img">
      <div class="header-text">
        <h1>诚信 精细 高效 务实</h1>
        <h2>About us</h2>
      </div>
    </div>
    <div class="crumbs-contain">
      <div>
        您的位置：
        <router-link tag="a" to="Home" class="home-title">首页</router-link
        ><i class="fa fa-angle-right" aria-hidden="true"></i
        ><router-link tag="a" to="About" class="new-name">公司简介</router-link>
      </div>
    </div>
    <div class="about-enterprise">
      <div
        class="tabs"
        @click="controlTab('1')"
        :class="tab == '1' ? 'active' : 'tabs'"
      >
        公司简介
      </div>
      <div
        class="tabs"
        @click="controlTab('2')"
        :class="tab == '2' ? 'active' : 'tabs'"
      >
        企业文化
      </div>
      <div
        class="tabs"
        @click="controlTab('3')"
        :class="tab == '3' ? 'active' : 'tabs'"
      >
        发展历程
      </div>
    </div>
    <div v-if="tab == '1'">
      <companyAbout></companyAbout>
    </div>
    <div v-if="tab == '2'">
      <companyCulture></companyCulture>
    </div>
    <div v-if="tab == '3'">
      <companyHistory></companyHistory>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import companyAbout from "@/views/About/common/companyAbout";
import companyCulture from "@/views/About/common/companyCulture";
import companyHistory from "@/views/About/common/companyHistory";
import bottom from "@/components/bottom";
export default {
  components: {
    companyAbout,
    companyCulture,
    companyHistory,
    bottom
  },
  data() {
    return {
      tab: "1"
    };
  },
  methods: {
    controlTab(row) {
      this.tab = row;
    }
  }
};
</script>

<style scoped lang="less">
.header-img {
  width: 100%;
  height: 300px;
  background: url(../../../static/images/server5.png) no-repeat center center;
  .header-text {
    width: 1170px;
    margin: 0 auto;
    padding-top: 100px;
    h1 {
      color: #3488ea;
      font-size: 28px;
      font-weight: 300;
      line-height: 0;
    }
    h2 {
      color: #464646;
      font-size: 24px;
      opacity: 0.9;
      font-family: "FZCYJ";
      letter-spacing: 1px;
      font-weight: 300;
    }
  }
}
.crumbs-contain {
  width: 1170px;
  margin: 0 auto;
  padding: 30px 0;
  color: #666666;
  font-size: 12px;
  .home-title {
    cursor: pointer;
    color: #666666;
    &:hover {
      color: #3488ea;
    }
  }
  .new-name {
    color: #3488ea;
    cursor: pointer;
  }
  .fa-angle-right {
    margin: 0 5px;
  }
}
.about-enterprise {
  width: 20%;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  .tabs {
    width: 106px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    color: #666666;
    font-size: 14px;
    cursor: pointer;
  }
  .active {
    width: 106px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    color: #ffffff;
    font-size: 14px;
    background: #333333;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/About/About.vue